//
import { RFormFields } from '../../../components/reusable_components/next'

//
import CustomerModel from '../../../models/Sale/SlCustomer'
import { RequiredRule } from '../../../mixins/reusable_mixins/rules'

//
export default new RFormFields(
    {
        name: 'number',
        type: 'text-field',
        props: {
            label: 'Numero',
            reverse: true,
        },
        variant: ['update'],
    },
    {
        name: 'sl_customer_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'business_name',
            itemValue: 'id',
            label: 'Cliente',
            model: CustomerModel,
            noObject: true,
            paramSearch: 'search',
        },
        variant: ['update'],
    },
    {
        name: 'emission_date',
        type: 'date-field',
        props: {
            label: 'Emision',
        },
        variant: ['update'],
    },
    {
        name: 'was_replaced_str',
        type: 'text-field',
        props: {
            label: 'Remplazada',
        },
        variant: ['update'],
    },
    {
        name: 'type_reference_document',
        type: 'select',
        props: {
            items: [
                /**{
                    text: 'Boleta',
                    value: 1,
                },**/
                {
                    text: 'Factura',
                    value: 2,
                },
                {
                    text: 'Nota de crédito',
                    value: 3,
                },
            ],
            label: 'Tipo de documento',
            rules: [RequiredRule],
        },
        variant: ['create', 'create-invoice'],
    },
    {
        name: 'dte_number',
        type: 'float-field',
        props: {
            label: 'DTE',
            rules: [RequiredRule],
        },
        slots: {
            'append': 'dte-number-append'
        },
        variant: ['create', 'create-invoice'],
    },
    {
        name: 'sl_sale_invoice_customer_business_name',
        type: 'text-field',
        props: {
            label: 'Cliente',
            readonly: true,
        },
        variant: ['create-invoice'],
    },
    {
        name: 'sl_sale_invoice_total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
        variant: ['create-invoice'],
    },
    {
        name: 'reason',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario',
            rules: [RequiredRule],
        },
        variant: ['create', 'create-invoice'],
    },
    {
        name: 'total_amount',
        type: 'currency-field',
        props: {
            label: 'Monto Nota de Debito',
            reverse: true,
            rules: [RequiredRule],
        },
        variant: ['create', 'create-invoice'],
    },
    {
        name: 'stock_return',
        type: 'switch',
        props: {
            label: 'Retornar stock',
        },
        variant: ['create', 'create-invoice'],
    },
    {
        name: 'net_total',
        type: 'currency-field',
        props: {
            label: 'Neto',
            reverse: true,
        },
        variant: ['update'],
    },
    {
        name: 'iva',
        type: 'currency-field',
        props: {
            label: 'IVA',
            reverse: true,
        },
        variant: ['update'],
    },
    {
        name: 'total',
        type: 'currency-field',
        props: {
            label: 'Total',
            reverse: true,
        },
        variant: ['update'],
    },
)
